import PolyCoordinate from "../PolyCoordinate";
import StraightSegment from "./StraightSegment";
import CurveSegment from "./CurveSegment";
import BezierSegment from "./BezierSegment";

export function createSegment(provider, coordData, parent, index, startCoord) {
    let endCoord = new PolyCoordinate(
        provider,
        coordData[0],
        coordData[1],
        parent,
        startCoord.index + 1
    );

    if (coordData.length === 2) {
        return new StraightSegment(provider, startCoord, endCoord, parent, index);
    }

    if (coordData[2] === "curve") {
        return new CurveSegment(provider, startCoord, endCoord, parent, index, coordData[3], coordData[4]);
    }

    if (coordData[2] === "bezier") {
        return new BezierSegment(provider, startCoord, endCoord, parent, index, coordData[3], coordData[4], coordData[5], coordData[6]);
    }

    return new StraightSegment(provider, startCoord, endCoord, parent, index);
}

export function createClosingSegment(provider, lastEnd, firstStart, parent, index, type, ...controlPoints) {
    if (type === 'curve') {
        return new CurveSegment(provider, lastEnd, firstStart, parent, index, controlPoints[0], controlPoints[1]);
    }
    if (type === 'bezier') {
        return new BezierSegment(provider, lastEnd, firstStart, parent, index, controlPoints[0], controlPoints[1], controlPoints[2], controlPoints[3]);
    }
    return new StraightSegment(provider, lastEnd, firstStart, parent, index);
}

export function createStraightSegment(provider, start, end, parent, index) {
    return new StraightSegment(provider, start, end, parent, index);
}

export function createCurveSegment(provider, start, end, parent, index, cpX, cpY) {
    return new CurveSegment(provider, start, end, parent, index, cpX, cpY);
}

export function createBezierSegment(provider, start, end, parent, index, cp1X, cp1Y, cp2X, cp2Y) {
    return new BezierSegment(provider, start, end, parent, index, cp1X, cp1Y, cp2X, cp2Y);
}
